import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import {
  formatBalance,
  callWriteContract,
  getTxn,
} from "../../../../Contract/utils";
import { toast } from "react-toastify";
import stakeContract from "../../../../Contract/stakContract.json";

function MyVerticallyCenteredModal(props) {
  const withdrawStake = async () => {
    try {
      const type = props.emer ? "emergencyWithdraw" : "withdraw";

      let load = toast.loading("Withdrawing...");

      const tx = await callWriteContract(
        stakeContract.address,
        stakeContract.abi,
        type,
        [props.id]
      );

      const status = await getTxn(tx);
      if (!status) {
        toast.error("Withdraw Failed!");
        toast.dismiss(load);
        return;
      }

      toast.success("Withdraw Successfull!");
      toast.dismiss(load);
      props.setTxn(tx);
      props.onHide();
    } catch (e) {
      console.log("error withdrawStake", e);
    }
  };

  return (
    <Modal
      className="wallet-modal reward"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <img src="/images/close.png" onClick={props.onHide} alt="" />
      </Modal.Header>
      <Modal.Body className="px-5">
        <div className="wallet-main">
          {props.emer && (
            <p className="text-center py-2 bg-danger text-white mb-1">
              20% will be deducted for early withdraw!
            </p>
          )}
          <div className="form-group">
            <div className="locked">
              <div style={{ width: "65%" }}>
                <h5>Locked Amount</h5>
                <h4>{formatBalance(props.amount, 18, 18)} ZEUSS</h4>
              </div>
              <div className="borderside">
                <h5>Duration</h5>
                <h4>
                  {props.duration === 15724800 ? "6 Months" : "12 Months"}
                </h4>
              </div>
            </div>
            <hr className="my-4" />
            {/* <img src="/images/separater.png" className="my-4" alt="" /> */}
            <div className="btns pb-5">
              <button
                type="button"
                class="btn back form-control"
                onClick={props.onHide}
              >
                Back
              </button>
              <button
                type="button"
                class="btn form-control"
                onClick={withdrawStake}
              >
                Claim
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default function Reward({
  show,
  amount,
  duration,
  emer,
  modal,
  id,
  setTxn,
}) {
  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    setModalShow(show);
  }, [show]);

  return (
    <>
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => {
          setModalShow(false);
          modal(false);
        }}
        amount={amount}
        duration={duration}
        emer={emer}
        id={id}
        setTxn={setTxn}
      />
    </>
  );
}
